import { getPlaceAverageRatingByPlaceId } from "@/api/places";
import Iconify from "@/components/ui/Iconify";
import { useTranslations } from "@/lib/static-intl";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";

const PlaceRatingAndType = ({ placeId, placeType }) => {
  const apiT = useTranslations("api");
  const [averageRating, setAverageRating] = useState(null);

  const fetchAverageRatingByPlaceId = async (placeId) => {
    try {
      const response = await getPlaceAverageRatingByPlaceId({
        placeId,
      });
      setAverageRating(response);
    } catch (error) {
      enqueueSnackbar(
        error?.response?.data?.message ||
        error?.message ||
        apiT("error message"),
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (placeId) fetchAverageRatingByPlaceId(placeId);
  }, [placeId]);

  if (!averageRating) return null;
  return (
    <span className="w-fit text-[11px] text-black/90 dark:text-white/90 font-semibold text-nowrap flex items-center tracking-tighter">
      <Iconify
        icon={"material-symbols:star"}
        className={"!text-yellow-400 !min-w-3 !h-3"}
      />
      {`${Number(averageRating?.naverRating) ||
        Number(averageRating?.averageRating).toFixed(1) ||
        Number(0.0).toFixed(1)
        } (
        ${Number(averageRating?.numberOfVisitorReviews).toFixed(0) ||
        averageRating?.totalReviews ||
        0
        }개)`}
      {placeType}
    </span>
  );
};

export default PlaceRatingAndType;
